
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import GuideHero from './components/GuideHero';
import GuideCards from './components/GuideCards';
import TaxAccountantTypes from './components/TaxAccountantTypes';
import GuideChecklist from './components/GuideChecklist';

const TaxAccountantGuidePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-20">
        <GuideHero />
        <GuideCards />
        <TaxAccountantTypes />
        <GuideChecklist />
      </main>
      <Footer />
    </div>
  );
};

export default TaxAccountantGuidePage;
